import "./Faq.module.css";
import Header from "@/reusable_sections/Header";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function FaqPage() {
  return <div>
      <Header />
      <Faq />
      <Footer />
    </div>;
}